import { RefObject, useEffect, useRef, useState } from 'react'

export const MIN_DAY_COLUMN_WIDTH = 132
export const CALENDAR_MIN_WIDTH = MIN_DAY_COLUMN_WIDTH * 7
const EVENT_TEXT_INSET = 26

export const useAvailableWidth = <T extends HTMLElement>(): [RefObject<T>, number] => {
  const ref = useRef<T>(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const element = ref.current
    if (!element) return
    const observer = new ResizeObserver(entries => {
      for (const entry of entries) setWidth(entry.contentRect.width)
    })
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  return [ref, width]
}

export const getDayColumnWidth = (availableWidth: number): number => Math.max(MIN_DAY_COLUMN_WIDTH, availableWidth / 7)

export const getEventTextMaxWidth = (availableWidth: number): number =>
  Math.round(getDayColumnWidth(availableWidth) - EVENT_TEXT_INSET)
